import { Component, ViewEncapsulation } from '@angular/core';

import { EmailImageAssetDirective } from '../../directives/email-image-asset.directive';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';

@Component({
  selector: 'email-tellent-products-footer',
  styleUrl: './tellent-products-footer.component.less',
  template: `
    <table class="tellent-logos-wrap">
      <tr>
        <td>
          <a href="https://recruitee.com/" target="_blank">
            <img
              class="logo"
              [src]="'assets/logo-footer-recruitee.png'"
              [width]="28"
              [height]="28"
              alt="Recruitee"
            />
          </a>
        </td>
        <td>
          <a href="https://kiwihr.com/" target="_blank">
            <img
              class="logo"
              [src]="'assets/logo-footer-kiwihr.png'"
              [width]="28"
              [height]="28"
              alt="KiwiHr"
            />
          </a>
        </td>
        <td>
          <a href="https://javelo.io/" target="_blank">
            <img
              class="logo"
              [src]="'assets/logo-footer-javelo.png'"
              [width]="28"
              [height]="28"
              alt="Javelo"
            />
          </a>
        </td>
      </tr>
    </table>
  `,
  imports: [EmailImageAssetDirective],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class TellentProductsFooterComponent {}
